<template>
    <v-select outlined :label="label" :items="items" item-text="full_name" item-value="id" :value="value"
              @input="syncInput"/>
</template>

<script>
    export default {
        props: {
            value: Number,
            label: String
        },

        data() {
            return {
                items: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.$http.get('project-managers').then(response => {
                    this.items = response.data.map(it => {
                        return {
                            id: it.id,
                            full_name: `${it.first_name} ${it.last_name}`
                        }
                    });
                })
            },
            syncInput(value) {
                this.$emit('input', value);
            }
        }
    }
</script>